// extracted by mini-css-extract-plugin
export var attribution = "_az-4";
export var authorName = "_az-5";
export var quote = "_az-3";
export var testimonial = "_az-2";
export var trustedBy = "_az-0";
export var trustedByLabel = "_az-1";